import React from 'react';
import { generateFAQPageSchema } from './generateFAQPageSchema';

export type FAQType = {
  question: string;
  answer: string;
};

export const FAQPageSchema = ({ faqs }: { faqs: FAQType[] }) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(generateFAQPageSchema(faqs)),
      }}
    />
  );
};
